import { Button } from '@gearbelt/ui/components';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';

import CloseIcon from '@/components/icons/close';
import DeleteIcon from '@/components/icons/delete';
import { Dialog, DialogClose, DialogContent, DialogDescription, DialogTitle } from '@/components/ui/dialog';

function SaveChangesDialog({
  open,
  onOpenChange,
  saveCallback,
  discardCallback,
  loading,
  title,
  description,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  saveCallback: () => void;
  discardCallback: () => void;
  loading: boolean;
  title: string;
  description: string;
}) {
  function handleSave() {
    saveCallback();
  }

  function handleDiscard() {
    discardCallback();
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="flex flex-col gap-[10px]">
        {/* Visually hidden for a11y */}
        <VisuallyHidden>
          <DialogTitle>{title}</DialogTitle>
        </VisuallyHidden>

        <DialogClose className="focus:ring-default-blue data-[state=open]:bg-default-blue/10 data-[state=open]:text-default-text ml-auto size-4 rounded-sm opacity-70 ring-offset-white transition-opacity hover:opacity-100 focus:ring-2 focus:ring-offset-2 focus:outline-none disabled:pointer-events-none">
          <CloseIcon className="h-4 w-4" />
          <span className="sr-only">Close</span>
        </DialogClose>

        <h1 className="text-center text-xl font-medium">{title}</h1>

        <DialogDescription className="text-center">{description}</DialogDescription>

        <div className="mt-4 flex justify-center gap-2">
          <Button variant="success" onClick={handleSave} loading={loading}>
            Save Changes
          </Button>
          <Button variant="destructive" icon={<DeleteIcon className="text-white" />} onClick={handleDiscard} disabled={loading}>
            Discard Changes
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export { SaveChangesDialog };
